import React from 'react';
import PropTypes from 'prop-types';
import getContent from '../../../lib/dictionaryFetcher';
import { products, BIG_COMMERCE } from '../lib/productBundlesStaticMapping';
import { get } from 'lodash';

class TermsConditions extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const bundles = this.props.bundles;
    let country = get(this.props, 'app.legalCountry', 'US');
    country = country === 'GB' ? 'UK' : country;
    let showBigCommerceTerms = false;
    Object.values(bundles).forEach(bundleObj => {
      if (
        (bundleObj.heroProduct && bundleObj.heroProduct === BIG_COMMERCE) ||
        (bundleObj.suggestedProducts &&
          bundleObj.suggestedProducts.includes(BIG_COMMERCE))
      ) {
        showBigCommerceTerms = true;
      }
    });
    let bigCommerceTerms = showBigCommerceTerms ? (
      <p
        className="ppvx_text--sm"
        id="bigCommerceTC"
        dangerouslySetInnerHTML={{
          __html: getContent('covidbundles', 'bigCommerce.terms', '', {
            params: { country }
          })
        }}
      ></p>
    ) : null;

    const fee = get(products, 'qrCode.fee', '');
    const tempWaiverDate = get(products, 'qrCode.tempWaiverDate', '');

    return (
      <div>
        <div className="termsSection">
          <p
            className="ppvx_text--sm"
            id="qrCodeTC"
            dangerouslySetInnerHTML={{
              __html: getContent('covidbundles', 'qrCode.terms', '', {
                params: { fee, tempWaiverDate }
              })
            }}
          ></p>
          {bigCommerceTerms}
        </div>
      </div>
    );
  }
}

TermsConditions.propTypes = {
  app: PropTypes.object,
  bundles: PropTypes.object
};

export default TermsConditions;
